module.exports = __webpack_public_path__ + "media/assets/icons/zidosya_icon-7253798c5052599a6803710d38d2f2f1.svg";